<template lang="pug">
    form-select(
    v-bind="Object.assign({}, $options.propsData, { name: codeSelect })",
    :value="value",
    @input="$emit('input', { [codeSelect]: $event })"
    )
</template>

<script>
    import FormSelect from './Select.vue';

    export default {
        components: {
            FormSelect
        },
        props: {
            name: String | Array,
            options: Array,
            placeholder: String,
            value: String | Number
        },
        computed: {
            codeSelect() {
                return Array.isArray(this.name) ? this.name[0] : this.name;
            },
            codeIcon() {
                return Array.isArray(this.name) ? this.name[1] : this.name;
            }
        },
        data() {
            return {
                opened: false
            };
        },
    };
</script>

<style lang="scss" scoped>
    .__form-calendar {

    }
</style>


// WEBPACK FOOTER //
// Calendar.vue?334d3e02